// ============================================================
// alt-text.js — Texto alternativo DERIVADO de los props del bloque.
//
// POR QUÉ EXISTE: de las 9 <img> que pintan los bloques solo 4 llevaban `alt`, y
// entre las que faltaban estaba la del HERO — la imagen LCP (`fetchpriority=high`),
// justo la que Google mira. El `alt` no puede hardcodearse (sería copy fijo, y aquí
// TODO lo escribe el cliente/la IA): se DERIVA en cada render de una cascada de
// props, con el campo manual `image_alt` mandando siempre.
//
// Cascada: image_alt (lo que el cliente escribe en el picker) → título/subtítulo del
// bloque → keyword de Unsplash ("modern-interior" → "modern interior"). Si no hay
// nada utilizable se emite alt="" (imagen decorativa), que es lo correcto para un
// lector de pantalla: mejor vacío que ruido.
// ============================================================
import { escapeHtml } from './dom.js';

// Los campos editables se persisten como innerHTML (el cliente edita inline y Chrome
// deja <br>/<b>/&nbsp;), así que hay que aplanarlos antes de meterlos en un atributo.
const _plano = (v) => String(v == null ? '' : v)
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();

// Una "keyword" de Unsplash solo sirve de texto si NO se resolvió ya a URL/data-uri
// (data-unsplash guarda la URL una vez resuelta). "modern-interior" → "modern interior".
const _deKeyword = (v) => {
    const s = _plano(v);
    if (!s || /^(https?:|\/|data:)/i.test(s)) return '';
    return s.replace(/[-_]+/g, ' ').trim();
};

/** Longitud razonable de un alt (los lectores de pantalla cortan mucho antes). */
const _MAX = 125;

/**
 * Primer candidato utilizable de la cascada, aplanado, recortado y ESCAPADO para
 * insertarlo en un atributo HTML.
 * @param {...string} candidatos  en orden de preferencia
 * @returns {string} texto seguro (puede ser '')
 */
export function textoAlt(...candidatos) {
    for (const c of candidatos) {
        const s = _deKeyword(c);
        if (s) return escapeHtml(s.length > _MAX ? s.slice(0, _MAX - 1).trimEnd() + '…' : s);
    }
    return '';
}

/**
 * Atributo `alt` ya listo para interpolar en el markup del bloque. SIEMPRE devuelve el
 * atributo (vacío si no hay candidato): una <img> sin `alt` es un error de accesibilidad,
 * una con alt="" es una decisión declarada.
 * Uso: `<img src="…" ${altAttr(p.image_alt, p.title, p.image_keyword)}>`
 */
export function altAttr(...candidatos) {
    return `alt="${textoAlt(...candidatos)}"`;
}
